export default __webpack_public_path__ + "static/media/gambrel.dcf8a38c.png";